<template>
  <vs-row vs-justify="center" id="ticket-box">
    <vs-col  type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <vs-row class="mt-4">
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12" align="left"  v-for="(lang, index) in languages" :key="index">
            <h3 style="margin-bottom: 10px;margin-top: 25px">{{ titles[index].value }} <span title="Remove" @click="removeLanguage(index)" v-if="titles[index].closable" style="color:#f62d51;cursor: pointer;font-size: 16px">X</span></h3>
            <VueEditor :id="index+'Editor'" v-model="languages[index]"/>
          </vs-col>
        </vs-row>
        <vs-row class="float-right m-4">
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12" align="left">

          <vs-dropdown vs-trigger-click class="cursor-pointer ml-md-4">
            <vs-button style="margin-right: 20px" color="warning">
              Add language
            </vs-button>
            <vs-dropdown-menu class="topbar-dd">
              <span v-for="(title, index) in titles" :key="index">
                  <vs-dropdown-item v-if="!title.selected && !allreadySet(index)" @click="addedLanguage(index)">{{title.value}}</vs-dropdown-item>
                </span>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button @click="validateInputs()" color="primary">{{
              $t("Organization.UpdateButton")
            }}</vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<script>

import { VueEditor } from "vue2-editor";
import {policyService} from "@/_services";
export default {
  name:'Policy',
  components: {VueEditor},
  data() {
    return {
      languages: [],
      titles: {
        en: {value:'English', selected:true, closable:false,},
        fr: {value:'Français', selected:true , closable:false,},
        ar: {value:'العربية', selected:true , closable:false,},
        es: {value:'Española', selected:false , closable:true,},
        pr: {value:'Portugues', selected:false,closable:true },
        de: {value:'Deutsche', selected:false,closable:true},
        py: {value:'Русский', selected:false,closable:true}
      },
    }
  },
  computed: {
  },
  methods: {
    allreadySet(index) {
      if (this.languages.hasOwnProperty(index)) {
        this.titles[index].selected = true;
        return true;
      }
      return false;
    },
    removeLanguage(index) {
      this.titles[index].selected = false;
      delete this.languages[index];
      const ln = this.languages;
      this.languages = [];
      setTimeout(()=>{
        this.languages = ln;
      },10);
    },
    addedLanguage(index) {
      this.titles[index].selected = true;
      this.languages[index] = "";
      const ln = this.languages;
      this.languages = [];
      setTimeout(()=>{
        this.languages = ln;
      },10);
    },
    showLoading() {
      this.$vs.loading({
        container: "#ticket-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#ticket-box > .con-vs-loading");
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateInputs() {
      this.showLoading();
      const content = {content: JSON.stringify(this.languages)};
      policyService.addPolicy(content)
          .then(()=>{
            this.notify(
                this.$t("Toasts.Success"),
                this.$t("Privacy policy updated successfully"),
                "success"
            );
          })
          .catch((err)=>{
            console.log(err);
            this.notify(
                this.$t("Toasts.Error"),
                this.$t("Error! please try again"),
                "danger"
            );
          })
          .finally(()=>{
            this.hideLoading();
          })
    },
  },
  mounted() {
    this.showLoading();
    policyService.getPolicy()
        .then((res)=>{
          if(res.policy) {
          this.languages = JSON.parse(res.policy.translations);
          } else {
            this.languages = { "en": "<p></p>", "fr": "<p></p>", "ar": "<p class='ql-align-right'></p>" }
          }
        })
        .catch(()=>{
          this.notify(
              this.$t("Toasts.Error"),
              this.$t("Error while loading privacy policy"),
              "danger"
          );
        })
        .finally(()=>{
          this.hideLoading();});
  }
}
</script>

<style>
.ql-toolbar .ql-formats .ql-image {
  display: none;
}
.ql-toolbar .ql-formats .ql-video {
  display: none;
}
</style>